"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navigation = void 0;
var Navigation = function () {
    var nav = document.querySelector(".nav");
    var submenuTrigger = document.querySelector(".submenu-trigger");
    var submenu = document.querySelector(".submenu");
    var mobileSubmenu = document.querySelector(".mobile-submenu");
    var mobileSubmenuContent = document.querySelector(".mobile-submenu__content");
    var menuList = document.querySelector(".mobile-submenu__content ul");
    var mobileSubmenuTrigger = document.querySelector(".mobile-submenu-trigger");
    var mobileSubmenuTriggerClose = document.querySelector(".mobile-submenu-trigger-close");
    var handleScroll = function () {
        return nav.classList.toggle("sticky", window.scrollY > 10);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    submenuTrigger.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        submenuTrigger.classList.toggle("active", !submenuTrigger.classList.contains("active"));
        submenu.classList.toggle("active", submenuTrigger.classList.contains("active"));
        nav.classList.toggle("active", submenuTrigger.classList.contains("active"));
    });
    document.addEventListener("click", function (e) {
        var target = e.target;
        if (target === nav || nav.contains(target))
            e.stopPropagation();
        else {
            submenuTrigger.classList.remove("active");
            submenu.classList.remove("active");
            nav.classList.remove("active");
        }
    });
    mobileSubmenuTrigger.addEventListener("click", function (e) {
        return mobileSubmenu.classList.add("active");
    });
    mobileSubmenuTriggerClose.addEventListener("click", function (e) {
        return mobileSubmenu.classList.remove("active");
    });
    mobileSubmenu.addEventListener("click", function (e) {
        var target = e.target;
        if (target === mobileSubmenuContent ||
            mobileSubmenuContent.contains(target))
            e.stopPropagation();
        else {
            mobileSubmenu.classList.remove("active");
        }
    });
    menuList.addEventListener("click", function (e) {
        return mobileSubmenu.classList.remove("active");
    });
};
exports.Navigation = Navigation;
